/*jslint browser: true, vars: true, nomen: true, indent: 4, maxlen: 180, plusplus: true, sloppy: true*/
/*global mdev: true,console: true, module: true ,require: true, AMap: true*/

var $ = window.$;
var document = window.document;
var _ = window._;

var Suggest = function (option) {
    this.option = _.extend({}, option);
    this.option.cityId = this.option.inputDom.attr('data-cityId') || 1;
};

var Model = require('model/service/vendor.js');

Suggest.prototype = {
    suggestOn: true,
    init: function () {
        var self = this;
        self.bind();
    },
    bind: function () {
        var self = this;
        var keyupHandle = _.debounce(function () {
            var txt = self.option.inputDom.val() || '';
            if (txt === '') {
                return;
            }
            if(self.option.type && self.option.type == 'rent') {
                Model.getRentSuggestions(self.option.cityId, txt, function (data) {
                    // console.log('data:', data);
                    // console.log("document.activeElement.tagName", document.activeElement.tagName);
                    if (self.suggestOn && document.activeElement.tagName == "INPUT" && data.code === '200') {
                        var temp = data.data.list;
                        for(var i=0; i< temp.length; i++){
                            temp[i]["proj_name_show"] = temp[i]["name"].replace(txt, "<span class='red'>"+txt+ "</span>");
                        }
                        self.option.renderByData(data.data.list);
                    }
                });
            } else if(self.option.type && self.option.type == 'second-hand') {
                Model.getEsfSuggestions(self.option.cityId, txt, function (data) {
                    // console.log('data:', data);
                    // console.log("document.activeElement.tagName", document.activeElement.tagName);
                    if (self.suggestOn && document.activeElement.tagName == "INPUT" && data.code === '200') {
                        var temp = data.data.list;
                        for(var i=0; i< temp.length; i++){
                            temp[i]["proj_name_show"] = temp[i]["name"].replace(txt, "<span class='red'>"+txt+ "</span>");
                        }
                        self.option.renderByData(data.data.list);
                    }
                });
            } else {

                Model.getLoupanSuggestions(self.option.cityId, txt, function (data) {
                    // console.log('data:', data);
                    // console.log("document.activeElement.tagName", document.activeElement.tagName);
                    if (self.suggestOn && document.activeElement.tagName == "INPUT" && data.code === '200') {
                        var temp = data.data.list;
                        for(var i=0; i< temp.length; i++){
                            temp[i]["str_show"] = temp[i].str.replace(txt, "<span class='red'>"+txt+ "</span>");
                            temp[i]["proj_name_show"] = temp[i]["proj_name"].replace(txt, "<span class='red'>"+txt+ "</span>");
                        }
                        self.option.renderByData(data.data.list);
                    }
                });
            }

        }, 500);
        self.option.inputDom.on('keyup', function (event) {
            if (self.suggestOn) {
                if(event.keyCode == 13 && self.option.inputEnter){
                    self.option.inputEnter();
                }else if(event.keyCode == 38 && self.option.upAndDownKey){
                    self.option.tempPid = self.option.upAndDownKey(-1);
                }else if(event.keyCode == 40 && self.option.upAndDownKey){
                    self.option.tempPid = self.option.upAndDownKey(1);
                }else{
                    self.option.tempPid = null;
                    keyupHandle();
                }
            } else if(event.keyCode == 13 && self.option.inputEnter){
                self.option.inputEnter();
            }
        }).click(function (e) {
            e.stopPropagation();
            if (self.suggestOn) {
                keyupHandle();
            }
        });

        $('body').click(function () {
            self.option.ulDom.hide();
        });
    }
};

module.exports = Suggest;



// WEBPACK FOOTER //
// ./src/assets/util/suggest.js